export const currencyChange = (currency) => {
    try {
        currency = currency.toUpperCase()
        if (currency == 'USD' || currency == 'USDT') return "$";
        if (currency == 'EUR') return "€";
        if (currency == 'GBP') return "£";
        return currency
    } catch (err) {
        return ''
    }
}